import { SectionSubPage } from "@/components/ui/admin/SectionSubPage";
import { useTranslations } from "@/lib/useTranslations";

export function EventsRedactionPage() {
  const t = useTranslations("events.redaction");
  return (
    <SectionSubPage
      eyebrow={t("eyebrow")}
      title={t("title")}
      description={t("description")}
    />
  );
}

export function EventsStatisticsPage() {
  const t = useTranslations("events.statistics");
  return (
    <SectionSubPage
      eyebrow={t("eyebrow")}
      title={t("title")}
      description={t("description")}
    />
  );
}
